
import { ValidationObserver } from 'vee-validate';

export default {
    components: {
        ValidationObserver
    },
    props: {
        totalSteps: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            activeStep: 1,
            buttonClicked: false
        };
    },
    computed: {
        firstStep() {
            return this.activeStep === 1;
        },
        lastStep() {
            return this.activeStep === this.totalSteps;
        }
    },
    methods: {
        previousStep() {
            if (!this.firstStep) {
                this.activeStep--;
            }
        },
        nextStep(invalid, pending) {
            if (!invalid && !pending) {
                if (!this.lastStep) {
                    this.activeStep++;
                } else {
                    this.$emit('submit');
                }
            } else {
                this.buttonClicked = true;
            }
        },
        editStep(step) {
            this.activeStep = step;
        },
        handleSubmit() {
            alert('submit');
        }
    }
};
